import { createSlice } from "@reduxjs/toolkit";

const initialState = {

    code: sessionStorage.getItem("sampleCode") || ""
};

const sampleSlice = createSlice({

    name: "sample",
    initialState,
    reducers: {
        setSampleCode: (state, action) => {
            state.code = action.payload;
            sessionStorage.setItem("sampleCode", action.payload);
        }
    }
});

export const { setSampleCode } = sampleSlice.actions;
export default sampleSlice.reducer;